import { VisitTemplate } from '@dreryk/egabinet-visit-frontend-api';

import { TextEditorValue } from '@dreryk/react-text-editor';

import { VisitTemplateFormBean } from './VisitTemplateForm.types';

export const mapVisitTemplateToFormTemplate = (visitTemplate?: VisitTemplate): VisitTemplateFormBean => ({
   name: visitTemplate?.name ?? '',
   subjectiveAssessment: visitTemplate?.physicalExamination
      ? TextEditorValue.fromFormatted(visitTemplate.physicalExamination)
      : null,
   recommendations: visitTemplate?.recommendations
      ? TextEditorValue.fromFormatted(visitTemplate.recommendations)
      : null,
   interview: visitTemplate?.interview ? TextEditorValue.fromFormatted(visitTemplate.interview) : null,
});
